/**
 * Tabs of a brand profile's detail view. Kept clear of the page component so
 * the route table can name a tab without pulling its chunk into the bundle.
 */

export const BRANDS_PATH = "/context-hub/brands";

export const BRAND_SETTINGS_SEGMENT = "brand-settings";

export const BRAND_SETTINGS_PATH = `${BRANDS_PATH}/${BRAND_SETTINGS_SEGMENT}`;

export type BrandProfileTab = "brand-kit" | typeof BRAND_SETTINGS_SEGMENT;
